import { matchPath } from "react-router-dom";
import { INNER_ROUTES } from "@app/dashboard/constants/inner-routes";

const disabledTestLiveRoutes = [
  INNER_ROUTES.SINGLE_TRANSACTION,
  INNER_ROUTES.SINGLE_QUICK_LINK,
  INNER_ROUTES.PAYME_SINGLE_TRANSACTION,
  INNER_ROUTES.SINGLE_ORDER,
  INNER_ROUTES.SINGLE_PAYMENT_INTEGRATION,
];

const hiddenTestLiveRoutes = [
  INNER_ROUTES.PAYME_SETTINGS,
  INNER_ROUTES.REPORTS,
  INNER_ROUTES.BALANCE,
  INNER_ROUTES.TRANSFERS,
  INNER_ROUTES.CHARGE_BACKS,
  INNER_ROUTES.SINGLE_TRANSFER,
  INNER_ROUTES.BUSINESS_PROFILE,
  INNER_ROUTES.USER_AND_PERMISSIONS,
  INNER_ROUTES.MANAGE_ROLES,
  INNER_ROUTES.CREATE_NEW_ROLE,
  INNER_ROUTES.ROLE_DETAILS,
  INNER_ROUTES.BUNDLES,
  INNER_ROUTES.CAMPAIGNS,
  INNER_ROUTES.SINGLE_CAMPAIGN,
  INNER_ROUTES.CAMPAIGN_ANALYSIS,
  INNER_ROUTES.SERVICES,
  INNER_ROUTES.RISK_CENTER,
  INNER_ROUTES.SINGLE_RISK_ITEM,
  INNER_ROUTES.SETTINGS,
  INNER_ROUTES.PROFILE_DETAILS,
  INNER_ROUTES.CHANGE_PASSWORD,
  INNER_ROUTES.IFRAMES,
  INNER_ROUTES.XERO,
  INNER_ROUTES.NOTIFICATIONS,
  INNER_ROUTES.BILLS,
  INNER_ROUTES.PAY_ADS,
  INNER_ROUTES.SINGLE_BILL,
  INNER_ROUTES.DISPUTES,
  INNER_ROUTES.SINGLE_DISPUTE,
]

export const isTestLiveModeDisabled = (path: string): boolean => {
  return disabledTestLiveRoutes.some((route) => matchPath({ path: route, end: true }, path));
};

export const isTestLiveModeHidden = (path: string): boolean => {
  return hiddenTestLiveRoutes.some((route) => matchPath({ path: route, end: true }, path));
};